<template>
  <div>
    <!-- Page Banner -->
    <section class="page-banner bgs-cover overlay pt-50 ban-h mob-ban" style="background-image: url(/assets/images/banner4.jpg)">
      <div class="container">
        <div class="banner-inner">
          <h1 class="page-title2 clr-000">{{ $t('services.itStaff.bannerTitle') }}<br><span>{{ $t('services.itStaff.bannerSubtitle') }}</span></h1>
        </div>
      </div>
    </section>

    <!-- Services Description -->
    <section>
      <div class="container ser-des">
        <p class="lh2 mob-ban-title mar-ser">
          {{ $t('services.itStaff.description') }}
        </p>
      </div>
    </section>

    <!-- Key Features Section -->
    <section class="about-section-six py-70 rpb-70 bg-bg1">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="section-title3 mb-35">
              <img src="/assets/images/opalina_logo.png" />
              <h2>{{ $t('services.itStaff.keyFeatures.title') }}</h2>
            </div>
          </div>
          <div class="col-md-8">
            <div class="about-six-content mr-0 rmr-0 wow fadeInLeft delay-0-2s pad-l-50">
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.itStaff.keyFeatures.items.costEffective.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.itStaff.keyFeatures.items.costEffective.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.itStaff.keyFeatures.items.onshoreOffshore.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.itStaff.keyFeatures.items.onshoreOffshore.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.itStaff.keyFeatures.items.noCommitments.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.itStaff.keyFeatures.items.noCommitments.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.itStaff.keyFeatures.items.supervisory.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.itStaff.keyFeatures.items.supervisory.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.itStaff.keyFeatures.items.topTalent.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.itStaff.keyFeatures.items.topTalent.description') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Benefits Section (Desktop) -->
    <section class="featured-section bgs-cover pt-60 rpt-95 pb-60 rpb-100 bg-bg2 hiw-disp1">
      <div class="container">
        <div class="QTT">
          <div class="col-md-8 col-sm-12 d-flex benefit_sec">
            <div class="col-md-6 col-sm-12 mt-50">
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12 animated">
                <ul class="feature-icon ta-c">
                  <router-link to="/enterprise-banking-services#BankingExpertise">
                    <li>
                      <img src="/assets/images/icon/turn-a.png" />
                      <h5>{{ $t('services.itStaff.benefits.items.quickTurnaround.title') }}</h5>
                      <p class="bank-exp">{{ $t('services.itStaff.benefits.items.quickTurnaround.description') }}</p>
                    </li>
                  </router-link>
                </ul>
              </div>
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12 animated">
                <ul class="feature-icon ta-c">
                  <router-link to="/enterprise-banking-services#BankingExpertise">
                    <li>
                      <img src="/assets/images/icon/seamless.png" />
                      <h5>{{ $t('services.itStaff.benefits.items.seamlessIntegration.title') }}</h5>
                      <p class="bank-exp">{{ $t('services.itStaff.benefits.items.seamlessIntegration.description') }}</p>
                    </li>
                  </router-link>
                </ul>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12 animated">
                <ul class="feature-icon ta-c">
                  <router-link to="/enterprise-banking-services#BankingExpertise">
                    <li>
                      <img src="/assets/images/icon/risk.png" />
                      <h5>{{ $t('services.itStaff.benefits.items.riskMitigation.title') }}</h5>
                      <p class="bank-exp">{{ $t('services.itStaff.benefits.items.riskMitigation.description') }}</p>
                    </li>
                  </router-link>
                </ul>
              </div>
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12 animated">
                <ul class="feature-icon ta-c">
                  <router-link to="/enterprise-banking-services#BankingExpertise">
                    <li>
                      <img src="/assets/images/icon/focus.png" />
                      <h5>{{ $t('services.itStaff.benefits.items.focusCore.title') }}</h5>
                      <p class="bank-exp">{{ $t('services.itStaff.benefits.items.focusCore.description') }}</p>
                    </li>
                  </router-link>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-4 section-title1 pt-80 mb-35 benefit_sec1">
            <h2>{{ $t('services.itStaff.benefits.title') }}</h2>
            <p>{{ $t('services.itStaff.benefits.description') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Benefits Section (Mobile) -->
    <section class="bgs-cover rpt-95 rpb-100 bg-bg2 hiw-disp hiw-mob-pad">
      <div class="container">
        <div class="benefit-flex">
          <div class="col-md-5 col-sm-12 section-title1 benefits-pl">
            <h2>{{ $t('services.itStaff.benefits.title') }}</h2>
            <p>{{ $t('services.itStaff.benefits.description') }}</p>
          </div>
        </div>
        <div class="col-md-7 col-sm-12 benefit-flex">
          <div class="col-md-6 col-sm-12 mt-50 benefit-flex">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-6">
              <ul class="feature-icon ta-c">
                <router-link to="/enterprise-banking-services#BankingExpertise">
                  <li>
                    <img src="/assets/images/icon/turn-a.png" />
                    <h5>{{ $t('services.itStaff.benefits.items.quickTurnaround.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.itStaff.benefits.items.quickTurnaround.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
            <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-6">
              <ul class="feature-icon ta-c">
                <router-link to="/enterprise-banking-services#BankingExpertise">
                  <li>
                    <img src="/assets/images/icon/seamless.png" />
                    <h5>{{ $t('services.itStaff.benefits.items.seamlessIntegration.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.itStaff.benefits.items.seamlessIntegration.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-md-6 col-sm-12 benefit-flex">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-6">
              <ul class="feature-icon ta-c">
                <router-link to="/enterprise-banking-services#BankingExpertise">
                  <li>
                    <img src="/assets/images/icon/risk.png" />
                    <h5>{{ $t('services.itStaff.benefits.items.riskMitigation.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.itStaff.benefits.items.riskMitigation.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
            <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-6">
              <ul class="feature-icon ta-c">
                <router-link to="/enterprise-banking-services#BankingExpertise">
                  <li>
                    <img src="/assets/images/icon/focus.png" />
                    <h5>{{ $t('services.itStaff.benefits.items.focusCore.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.itStaff.benefits.items.focusCore.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- How It Works Section (Desktop) -->
    <section class="about-section-eight rpt-35 rpb-100 hiw-disp hiw-mob-pad hiw-tab">
      <div class="container">
        <h1 class="hiw hiw-pb">{{ $t('services.itStaff.howItWorks.title') }}</h1>
        <div class="col-md-12 d-flex justify-content-between align-items-center hiw-b">
          <div class="circ1">1</div>
          <div class="t-right">
            <h3>{{ $t('services.itStaff.howItWorks.steps.requirementAnalysis.title') }}</h3>
            <p>{{ $t('services.itStaff.howItWorks.steps.requirementAnalysis.description') }}</p>
          </div>
        </div>
        <div class="col-md-12 d-flex justify-content-between align-items-center hiw-b">
          <div class="circ2">2</div>
          <div class="t-left">
            <h3>{{ $t('services.itStaff.howItWorks.steps.talentSourcing.title') }}</h3>
            <p>{{ $t('services.itStaff.howItWorks.steps.talentSourcing.description') }}</p>
          </div>
        </div>
        <div class="col-md-12 d-flex justify-content-between align-items-center hiw-b">
          <div class="circ1">3</div>
          <div class="t-right">
            <h3>{{ $t('services.itStaff.howItWorks.steps.teamIntegration.title') }}</h3>
            <p>{{ $t('services.itStaff.howItWorks.steps.teamIntegration.description') }}</p>
          </div>
        </div>
        <div class="col-md-12 d-flex justify-content-between align-items-center hiw-b">
          <div class="circ2">4</div>
          <div class="t-left">
            <h3>{{ $t('services.itStaff.howItWorks.steps.ongoingSupport.title') }}</h3>
            <p>{{ $t('services.itStaff.howItWorks.steps.ongoingSupport.description') }}</p>
          </div>
        </div>
        <div class="col-md-12 d-flex justify-content-between align-items-center hiw-b">
          <div class="circ1">5</div>
          <div class="t-right">
            <h3>{{ $t('services.itStaff.howItWorks.steps.flexibilityScale.title') }}</h3>
            <p>{{ $t('services.itStaff.howItWorks.steps.flexibilityScale.description') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- How It Works Section (Mobile) -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 mb-80 hiw-disp1 hiw-tab1">
      <div class="container">
        <h1 class="hiw mb-50">{{ $t('services.itStaff.howItWorks.title') }}</h1>
        <div class="col-md-12 d-flex justify-content-between">
          <div class="col-md-5">
            <div class="col-md-12 d-flex justify-content-between align-items-center hiw-b mb-70">
              <div class="t-right">
                <h3>{{ $t('services.itStaff.howItWorks.steps.requirementAnalysis.title') }}</h3>
                <p>{{ $t('services.itStaff.howItWorks.steps.requirementAnalysis.description') }}</p>
              </div>
              <div class="circ1">1</div>
            </div>
            <div class="col-md-12 d-flex justify-content-between align-items-center hiw-b mb-70">
              <div class="t-right">
                <h3>{{ $t('services.itStaff.howItWorks.steps.teamIntegration.title') }}</h3>
                <p>{{ $t('services.itStaff.howItWorks.steps.teamIntegration.description') }}</p>
              </div>
              <div class="circ1">3</div>
            </div>
            <div class="col-md-12 d-flex justify-content-between align-items-center hiw-b">
              <div class="t-right">
                <h3>{{ $t('services.itStaff.howItWorks.steps.flexibilityScale.title') }}</h3>
                <p>{{ $t('services.itStaff.howItWorks.steps.flexibilityScale.description') }}</p>
              </div>
              <div class="circ1">5</div>
            </div>
          </div>
          <div class="col-md-2 border1">
            <img src="/assets/images/icon/border.png" />
          </div>
          <div class="col-md-5 mt-10">
            <div class="col-md-12 d-flex justify-content-between align-items-center hiw-b mt-100 mb-70">
              <div class="circ2">2</div>
              <div class="t-left">
                <h3>{{ $t('services.itStaff.howItWorks.steps.talentSourcing.title') }}</h3>
                <p>{{ $t('services.itStaff.howItWorks.steps.talentSourcing.description') }}</p>
              </div>
            </div>
            <div class="col-md-12 d-flex justify-content-between align-items-center hiw-b">
              <div class="circ2">4</div>
              <div class="t-left">
                <h3>{{ $t('services.itStaff.howItWorks.steps.ongoingSupport.title') }}</h3>
                <p>{{ $t('services.itStaff.howItWorks.steps.ongoingSupport.description') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 back-end" style="background-image: url(/assets/images/lets_build.jpg)">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 mt-40">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w dclr-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="lets">
                    <img src="/assets/images/opalina_logo.png" />
                    <h2>{{ $t('services.itStaff.callToAction.title') }}</h2>
                    <button>{{ $t('services.itStaff.callToAction.button') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!-- Empty column for spacing -->
          </div>
        </div>
      </div>
    </section>

    <!-- Services Offered Title -->
    <div>
      <h1 class="hiw mt-50">{{ $t('services.itStaff.servicesOffered.title') }}</h1>
    </div>

    <!-- Expertise Section -->
    <section class="about-section-eight pt-60 rpt-35 pb-60 rpb-100 pad-btm_imp" id="Expertise">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/company.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.itStaff.servicesOffered.expertise.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(item, index) in $tm('services.itStaff.servicesOffered.expertise.items')" :key="index">
                  <p v-html="item"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Domains Served Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 pad-btm_imp" id="Domainsserved">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order1">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.itStaff.servicesOffered.domains.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(item, index) in $tm('services.itStaff.servicesOffered.domains.items')" :key="index">
                  <p v-html="item"></p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/domain.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Technologies Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp" id="Technologies">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/techno.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.itStaff.servicesOffered.technologies.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(item, index) in $tm('services.itStaff.servicesOffered.technologies.items')" :key="index">
                  <p v-html="item"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- QA Process Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 pad-btm_imp" id="QAProcess">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order1">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.itStaff.servicesOffered.qaProcess.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three mt-15">
                <li v-for="(item, index) in $tm('services.itStaff.servicesOffered.qaProcess.items')" :key="index">
                  <p v-html="item"></p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/qa.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Facilities Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp" id="Facilitiesweprovide">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/laptop.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.itStaff.servicesOffered.facilities.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(item, index) in $tm('services.itStaff.servicesOffered.facilities.items')" :key="index">
                  <p v-html="item"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Additional Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 pad-btm_imp" id="Additional">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order1">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.itStaff.servicesOffered.additional.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(item, index) in $tm('services.itStaff.servicesOffered.additional.items')" :key="index">
                  <p v-html="item"></p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/offcie-w.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Offerings Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp" id="Offerings">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/tesm.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.itStaff.servicesOffered.offerings.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(item, index) in $tm('services.itStaff.servicesOffered.offerings.items')" :key="index">
                  <p v-html="item"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Hiring Training Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-70 rpb-70 bg-bg1 pad-btm_imp" id="HiringTraining">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order1">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.itStaff.servicesOffered.hiringTraining.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(item, index) in $tm('services.itStaff.servicesOffered.hiringTraining.items')" :key="index">
                  <p v-html="item"></p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/training.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ServicesITStaff'
}
</script>
